import ValidatedInput from "components/addForm/ValidatedInput";
import DescriptionGenerator from "components/addForm/autoGenerateDescription";

const FeaturesConfig = {
  value_template: (props) => {
    return  <ValidatedInput
    name="value_template"
    label="Value Template"
    placeholder="Enter Value Template"
    type="text"
    onChange={props.onChange}
    value={props.formData?.value_template || ""}
    isRequired={true}
    {...props}
  />
  },
  key: (props) => {
    return <ValidatedInput
    name="key"
    label="Key"
    placeholder="Enter Key"
    type="text"
    isRequired={true}
    onChange={props.onChange}
    value={props.formData?.key || ""}
    {...props}
  />
  },
  label: (props) => {
    return <ValidatedInput
    name="label"
    label="Label"
    placeholder="Enter Label"
    type="text"
    value={props.formData?.label || ""}
    onChange={props.onChange}
    isRequired={true}
    {...props}
  />
  },
  description: (props) => {
    return <DescriptionGenerator
    onChange={props.onChange}
    formData={props.formData}
    name="description"
    label="Description"
    placeholder="Enter Description"
    showButton={false}
    maxLength={300}
    value={props.formData?.description || ""}
    error={props.error}
  />
  },
};

export default FeaturesConfig;
